<template>
  <task-tree>
    <el-container class="collect-index-container">
      <el-main>
        <template v-for="(item, index) in cards">
          <div :key="index" class="task-card" :class="item.class">
            <div class="header" :class="item.bgClass">
              <jee-icon :iconClass="item.icon"/>
              <span class="title">{{item.title}}</span>
            </div>
            <div class="content" v-html="item.content">{{item.content}}</div>
            <el-button type="primary" @click="handleClickCreate(item.type)"
              :disabled="!_checkPermission('/admin/collectTasks', 'POST')"
            >创建任务</el-button>
          </div>
        </template>
      </el-main>
    </el-container>
  </task-tree>
</template>
<script>
import TaskTree from './TaskTree'
export default {
  name: 'interactCollectIndex',
  components: {
    TaskTree
  },
  data () {
    return {
      cards: [
        {
          title: '快速采集',
          class: 'fast',
          bgClass: 'jee-bg-light',
          icon: 'kuaisucaiji',
          content: '选用系统内置采集模板，无需设置，<br/>快速采集主流网站数据',
          type: 'FastTask'
        },
        {
          title: '自定义采集',
          class: 'custom',
          bgClass: 'customBg',
          icon: 'zidingyicaiji',
          content: '可以智能分析网页结构，自定义采集<br/>数据，通用且功能强大',
          type: 'CustomTask'
        }
      ]
    }
  },
  methods: {
    handleClickCreate (key) {
      switch (key) {
        case 'FastTask':
          this.$router.push({
            name: 'interactCollectCreateFast'
          })
          break
        case 'CustomTask':
          this.$router.push({
            name: 'interactCollectCreateCustom'
          })
          break
        default:
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.collect-index-container{
  .el-main{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .task-card + .task-card{
      margin-left: 70px;
    }
    .task-card {
      width: 300px;
      height: 360px;
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 10px;
      position: relative;
      .header{
        width: 100%;
        height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        .jee-svg-icon{
          fill: #ffffff;
          padding-right: 17px;
          font-size: 44px;
        }
        .title{
          color: #ffffff;
          font-size: 30px;
        }
        &.customBg{
          background-color: #1EA1DF;
          .jee-svg-icon{
            padding-right: 20px;
          }
        }
      }
      .content{
        font-size: 14px;
        color: #666666;
        line-height: 28px;
        padding-top: 30px;
        text-align: center;
      }
      .el-button{
        position: absolute;
        bottom: 25px;
        left: 50%;
        margin-left: -50px;
      }
      &.custom{
        .el-button{
          background-color: #1EA1DF;
          border-color: #1EA1DF;
        }
      }
    }
  }
}
</style>
